import { Fragment, ReactNode } from 'react';

const replaceTokensWithElements =
  () =>
  (
    message: string,
    elements: ReactNode[],
    className?: string,
    token = /\{\d+\}/
  ) => {
    const split = message.split(token);
    return split.map((messageSlice, index) => {
      const elementKey = `${messageSlice}_${index}`;
      return (
        <Fragment key={elementKey}>
          {split[index] ? (
            <span className={className} data-testid="span">
              {messageSlice}
            </span>
          ) : null}
          {elements[index] ? elements[index] : null}
        </Fragment>
      );
    });
  };

export default replaceTokensWithElements;
